export default "__VITE_ASSET__Db396Ono__"